const FileIcon = () => {
  return (
    <svg className="file-icon" width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.5 1H2C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V10C1 10.2652 1.10536 10.5196 1.29289 10.7071C1.48043 10.8946 1.73478 11 2 11H8C8.26522 11 8.51957 10.8946 8.70711 10.7071C8.89464 10.5196 9 10.2652 9 10V4.5L5.5 1Z" stroke="#F9F9FB" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5.5 1V4.5H9" stroke="#F9F9FB" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

export default FileIcon